module.exports = __webpack_public_path__ + "img/image144.2b5613a3.jpg";